import { render, staticRenderFns } from "./VAuctionFormControls.vue?vue&type=template&id=1f0289d3"
import script from "./VAuctionFormControls.vue?vue&type=script&lang=js"
export * from "./VAuctionFormControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports